import React from 'react';
import { Plus, Eye, Edit, Trash2 } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { useNavigate } from 'react-router-dom';
export function CreditTypes() {
  const navigate = useNavigate();
  const types = [{
    id: 1,
    name: '3 hrs. Agency Law'
  }, {
    id: 2,
    name: '3 hrs. Legal Issues'
  }, {
    id: 3,
    name: '3 hrs. Fair Housing'
  }, {
    id: 4,
    name: '3 hrs. Contract Law'
  }, {
    id: 5,
    name: '3 hrs. Comm. Standards'
  }, {
    id: 6,
    name: '3 hrs. Disclosure'
  }, {
    id: 7,
    name: '3 hrs. General'
  }, {
    id: 8,
    name: 'NONE'
  }, {
    id: 9,
    name: 'Req. For Licensees'
  }];
  return <div className="space-y-4" data-id="element-423" data-mp="1akyjl3lfwj0n">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-424" data-mp="1am9nr4isrssa">Credit Types</h1>

      <div data-id="element-425" data-mp="15rvmwmld8tg8">
        <Button size="sm" variant="secondary" className="gap-1.5 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/credit-types/add')} data-id="element-426" data-mp="15s5g0j1pjgq5">
          <Plus className="h-3.5 w-3.5 text-green-600" data-id="element-427" data-mp="3szhp9jhhksuu" />
          Add
        </Button>
      </div>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-428" data-mp="1s5crhrjt3l9">
        <div className="overflow-x-auto" data-id="element-429" data-mp="3j0s8xv58nggp">
          <table className="w-full text-sm text-left" data-id="element-430" data-mp="3izqvjk0r2hvt">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-431" data-mp="3nzvedgp4rop7">
              <tr data-id="element-432" data-mp="3o16hrfenyufs">
                <th className="px-3 py-3 border-r border-slate-700" data-id="element-433" data-mp="3nxiomhd4sa1l">Name</th>
                <th className="px-3 py-3 text-center w-36" data-id="element-434" data-mp="3a1yfuer4987w">
                  <div data-id="element-435" data-mp="3eyf4rb653qm1">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-436" data-mp="3ezgrwe0fk3k4">
                    View | Edit | Delete
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-437" data-mp="1d7buin05we20">
              {types.map(type => <tr key={type.id} className="hover:bg-slate-50" data-id="element-438" data-mp="1auqbiten73b3">
                  <td className="px-3 py-2.5 border-r border-slate-200" data-id="element-439" data-mp="16rbvw3um8oy6">
                    {type.name}
                  </td>
                  <td className="px-3 py-2.5 text-center" data-id="element-440" data-mp="11t0mfu88gggh">
                    <div className="flex items-center justify-center gap-2" data-id="element-441" data-mp="wtxg86gio46x">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/credit-types/view/${type.id}`)} data-id="element-442" data-mp="1uh67yj7429hd">
                        <Eye className="h-4 w-4" data-id="element-443" data-mp="1fs9qjvj5zk43" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/credit-types/edit/${type.id}`)} data-id="element-444" data-mp="1fq5prmgkb181">
                        <Edit className="h-4 w-4" data-id="element-445" data-mp="2fu6esmg2q1ls" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-446" data-mp="2krf2f2jzqxuf">
                        <Trash2 className="h-4 w-4" data-id="element-447" data-mp="2uqe0xsb1ld3p" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="text-xs text-slate-600" data-id="element-448" data-mp="33o7vaxp8xwo8">
        Page 1 of 1, showing 9 records out of 9 total, starting on record 1,
        ending on 9
      </div>
      <div className="text-sm text-blue-600 flex items-center gap-1" data-id="element-449" data-mp="3dgdkjzo45zzq">
        <button className="hover:underline" data-id="element-450" data-mp="3dhosmboldtwn">&lt;&lt; previous</button>
        <span className="text-slate-400" data-id="element-451" data-mp="3igrvpql0hq1z">|</span>
        <span className="text-slate-900 font-medium" data-id="element-452" data-mp="3mg0oot889jwh">1</span>
        <span className="text-slate-400" data-id="element-453" data-mp="3mefuj4pts2z5">|</span>
        <button className="hover:underline" data-id="element-454" data-mp="nz7q4qj2d06q">next &gt;&gt;</button>
      </div>
    </div>;
}